<template>
	<div class="maoFirstLanguage grid-x">
		<div class="maoFirstLanguage-content">
			<img class="logo" alt="Logo MAO" :src="logoPath" >
			<div v-html="appDataStore.appData.languages.welcome" class="intro-heading"></div>
			<div class="languages" :class="{ active: langs }">
				<MaoButton fullwidth v-for="lang in appDataStore.appData.languages.langs" :key="lang" variant="opacity-dark" :label="lang.native_name" @click="() => changeLang(lang.code)" />
			</div>
		</div>
	</div>
</template>

<script>
import { useAppDataStore } from "./../stores/appData";
import { useBottomMenuStore } from "@/stores/bottomMenu.js";

import MaoButton from "./../components/MaoButton.vue";
export default {
	name: "maoFirstLanguage",
	components: {
		MaoButton,
	},
	data() {
		return {
			isAnimating: false,
			end: false,
			preloaded: false,
			logoPath: require("@/assets/logo.png"),
		};
	},
	setup() {
		const appDataStore = useAppDataStore();
		const bottomMenuStore = useBottomMenuStore();

		const setLang = appDataStore.setLang;

		return { appDataStore, bottomMenuStore, setLang };
	},
	
	methods: {
		changeLang(lang) {
			localStorage.setItem("firstLanguageLang", lang);
			//this.setLang(lang);
			this.$emit("onSelectLang", lang);
		},
	},
	mounted() {

	},
};
</script>
<style lang="scss">
.intro-heading {
	p {
	min-height: 1rem;
}
}
</style>
<style scoped lang="scss">

.logo {
	width: 3rem;
    margin-bottom: 2rem;
}

.maoFirstLanguage {
	background-color: var(--surface-primary-container);
	position: fixed;
    inset: 0;
    z-index: 12;
	padding: var(--padding-l);

	[class*="icon-"] {
		font-size: var(--icon-size-xl);
	}

	.languages {
		display: flex;
		flex-direction: column;
		gap: var(--gap-m);
	}

	.maoFirstLanguage-content {
		grid-column: main-column;
		display: flex;
		flex-direction: column;
		.maoFirstLanguage-step {
			display: flex;
			flex-direction: column;
			gap: var(--padding-xxl);
			min-height: 60vh;
			.heading {
				display: flex;
				flex-direction: column;
				gap: var(--gap-m);
			}
			.maoFirstLanguage-icons {
				display: flex;
				gap: var(--gap-m);
			}
		}
	}
	.buttons {
		display: flex;
		gap: var(--gap-m);
		margin-toP: var(--gap-l);
	}
}
.flicking-pagination-scroll {
    position: relative;
    transform: none;
    left: auto !important;
    right: 0 !important;
	overflow: visible !important;
}
</style>
<style>
	@import url("@egjs/vue3-flicking/dist/flicking.css");
	@import url("@egjs/flicking-plugins/dist/pagination.css");

	.flicking-panel {
		width: 100%;
		text-wrap: balance;
		word-wrap: break-word;
	}
</style>
